'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ScrollTrigger = undefined;

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _lodashEs = require('lodash-es');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
  The static ScrollActions object performs callbacks on all registered triggers.

  ScrollActions.registerTrigger() and ScrollActions.deregisterTrigger() accept
  ScrollTrigger instances.
 */
var ScrollActions = {
  isRunning: false,
  isUsingSmoothScrollbar: false,
  smoothScrollbar: null,

  triggers: [],
  hasScheduledAnimationFrames: [],

  registerTrigger: function registerTrigger(scrollTrigger) {
    if (ScrollActions.triggers.indexOf(scrollTrigger) !== -1) return;

    ScrollActions.triggers.push(scrollTrigger);
    ScrollActions.hasScheduledAnimationFrames.push(false);
  },

  deregisterTrigger: function deregisterTrigger(scrollTrigger) {
    var index = ScrollActions.triggers.indexOf(scrollTrigger);
    if (index !== -1) {
      ScrollActions.triggers.splice(index, 1);
      ScrollActions.hasScheduledAnimationFrames.splice(index, 1);
    }
  },

  init: function init() {
    if (ScrollActions.isRunning || typeof window === 'undefined') return;

    window.addEventListener('scroll', ScrollActions.onScroll);
    ScrollActions.isRunning = true;
    ScrollActions.onScroll();
  },

  destroy: function destroy() {
    window.removeEventListener('scroll', ScrollActions.onScroll);
    ScrollActions.triggers = [];
    ScrollActions.hasScheduledAnimationFrames = [];
    ScrollActions.isRunning = false;
  },

  getPercent: function getPercent(startY, stopY, screenTop) {
    if (screenTop < startY) return 0;
    if (screenTop > stopY) return 1;

    var diff = screenTop - startY;
    var percent = diff / (stopY - startY);

    return percent;
  },

  scheduleCallback: function scheduleCallback(ti, callback) {
    for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
      args[_key - 2] = arguments[_key];
    }

    ScrollActions.hasScheduledAnimationFrames[ti] = true;
    window.requestAnimationFrame(function () {
      ScrollActions.hasScheduledAnimationFrames[ti] = false;
      callback.apply(undefined, args);
    });
  },

  onScroll: function onScroll() {
    var screenTop = window.pageYOffset;

    ScrollActions.triggers.forEach(function (trigger, ti) {
      if (ScrollActions.hasScheduledAnimationFrames[ti]) {
        return;
      }

      var startY = trigger.startY,
          stopY = trigger.stopY,
          lastPercent = trigger.lastPercent,
          callback = trigger.callback;


      if (Array.isArray(startY)) {
        // The startY object has an array of trigger points
        var i = 0;
        for (i = 0; i < startY.length; i++) {
          if (screenTop < startY[i]) break;
        }

        if (i === 0) {
          ScrollActions.scheduleCallback(ti, callback, 0, 0);
        } else {
          i--;
          var percent = ScrollActions.getPercent(startY[i], stopY[i], screenTop);
          if (!lastPercent || lastPercent.index !== i || lastPercent.percent !== percent) {
            trigger.lastPercent = { index: i, percent: percent };
            ScrollActions.scheduleCallback(ti, callback, percent, i);
          }
        }
      } else {
        // The startY object is one trigger point
        var _percent = ScrollActions.getPercent(startY, stopY, screenTop);
        if (lastPercent !== _percent) {
          trigger.lastPercent = _percent;
          ScrollActions.scheduleCallback(ti, callback, _percent);
        }
      }
    });
  }
};

ScrollActions.throttledOnScroll = (0, _lodashEs.throttle)(ScrollActions.onScroll, 35);

exports.default = ScrollActions;

/**
  The measure(screenTop, screenHeight) function needs to return the
  [startY, stopY] array.
  startY and stopY can be single y values, or arrays of y values

  The callback(percent) function receives the percent of the distance the
  pageYOffset has travelled from startY to stopY.

  If your startY and stopY are arrays, then the callback(index, percent)
  function receives the index of the startTrigger
 */

var ScrollTrigger = exports.ScrollTrigger = function ScrollTrigger(measure, callback, smoothScrollbar) {
  var _this = this;

  (0, _classCallCheck3.default)(this, ScrollTrigger);

  this.init = function () {
    ScrollActions.registerTrigger(_this);
    window.addEventListener('resize', _this.onResize);
    _this.onResize();

    if (!ScrollActions.isRunning) ScrollActions.init();
  };

  this.destroy = function () {
    ScrollActions.deregisterTrigger(_this);
    window.removeEventListener('resize', _this.onResize);
  };

  this.onResize = function () {
    var _window = window,
        pageYOffset = _window.pageYOffset,
        innerHeight = _window.innerHeight;

    var _measure = _this.measure(pageYOffset, innerHeight);

    var _measure2 = (0, _slicedToArray3.default)(_measure, 2);

    _this.startY = _measure2[0];
    _this.stopY = _measure2[1];


    ScrollActions.throttledOnScroll();
  };

  this.measure = measure;
  this.callback = callback;

  this.init(smoothScrollbar);
};